import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ReactiveFormsModule } from '@angular/forms';
import { CKEditorModule } from 'ngx-ckeditor';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';


import { AdvancedengineeringRoutingModule } from './advancedengineering-routing.module';
import { AdvancedListComponent } from './advanced-list/advanced-list.component';
import { AdvancedCreateComponent } from './advanced-create/advanced-create.component';

@NgModule({
  declarations: [AdvancedListComponent, AdvancedCreateComponent],
  imports: [
    CommonModule,
    AdvancedengineeringRoutingModule,
    NgbModule,
    ReactiveFormsModule,
    CKEditorModule,
    NgxDatatableModule
  ]
})
export class AdvancedengineeringModule { }
